import { render, staticRenderFns } from "./ExpandableContent.vue?vue&type=template&id=7f6c060a&scoped=true&"
import script from "./ExpandableContent.vue?vue&type=script&lang=js&"
export * from "./ExpandableContent.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableContent.vue?vue&type=style&index=0&id=7f6c060a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c060a",
  null
  
)

export default component.exports